'use client';

import React, { type ReactNode } from 'react';
import { Condition } from '@/shared/ui/condition';
import {
  ContentWrapper,
  FooterWrapper,
  MainContentWrapper,
  MainWrapper,
  MobileMenuWrapper,
  UnderHeaderWrapper,
} from './styles';

interface ResponsiveLayoutFrameProps {
  children: ReactNode;
  flexMain?: boolean;
  withoutMobileMenuPadding?: boolean;
}

export const ResponsiveLayoutFrame = ({
  children,
  flexMain,
  withoutMobileMenuPadding = false,
}: ResponsiveLayoutFrameProps) => (
  <MobileMenuWrapper $flexMain={flexMain}>
    <ContentWrapper
      $withoutMenu={withoutMobileMenuPadding}
      $flexMain={flexMain}
    >
      {children}
    </ContentWrapper>
  </MobileMenuWrapper>
);

interface MainContentFrameProps {
  children: ReactNode;
  flexMain?: boolean;
  footer: ReactNode;
  hideFooter?: boolean;
  mobileMenu: ReactNode;
}

export const MainContentFrame = ({
  children,
  flexMain,
  footer,
  hideFooter = false,
  mobileMenu,
}: MainContentFrameProps) => (
  <UnderHeaderWrapper>
    <MainContentWrapper>
      <MainWrapper $flexMain={flexMain}>{children}</MainWrapper>
      <Condition match={!hideFooter}>
        <FooterWrapper data-global-footer="true">{footer}</FooterWrapper>
      </Condition>
    </MainContentWrapper>
    {mobileMenu}
  </UnderHeaderWrapper>
);
